import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { BrainView } from "../mobile/brainMobileViews";
import { useWaveTimers } from "@/hooks/useWaveTimers";
type RegisterTabRef = (view: BrainView, el: HTMLButtonElement | null) => void;
interface MyStreamWaveTabsLeaderboardProps {
  readonly wave: ApiWave;
  readonly activeView: BrainView;
  readonly onViewChange: (view: BrainView) => void;
  readonly registerTabRef?: RegisterTabRef | undefined;
  readonly renderAfterLeaderboard?: React.ReactNode;
}
const MyStreamWaveTabsLeaderboard: React.FC<MyStreamWaveTabsLeaderboardProps> = t0 => {
  const $ = _c(24);
  const {
    wave,
    activeView,
    onViewChange,
    registerTabRef,
    renderAfterLeaderboard
  } = t0;
  const {
    voting: t1,
    decisions: t2
  } = useWaveTimers(wave);
  const {
    isCompleted
  } = t1;
  const {
    firstDecisionDone
  } = t2;
  const primaryView = isCompleted ? BrainView.SUBMISSIONS : BrainView.LEADERBOARD;
  const primaryLabel = isCompleted ? "Submissions" : "Leaderboard";
  const leaderboardButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-7 tw-rounded-lg ${activeView === primaryView ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const leaderboardButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === primaryView ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const winnersButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-7 tw-rounded-lg ${activeView === BrainView.WINNERS ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const winnersButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.WINNERS ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  let t3;
  if ($[0] !== primaryView || $[1] !== registerTabRef) {
    t3 = el => {
      registerTabRef?.(primaryView, el);
    };
    $[0] = primaryView;
    $[1] = registerTabRef;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onViewChange || $[4] !== primaryView) {
    t4 = () => onViewChange(primaryView);
    $[3] = onViewChange;
    $[4] = primaryView;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== leaderboardButtonTextClasses || $[7] !== primaryLabel) {
    t5 = <span className={leaderboardButtonTextClasses}>{primaryLabel}</span>;
    $[6] = leaderboardButtonTextClasses;
    $[7] = primaryLabel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== leaderboardButtonClasses || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <button ref={t3} onClick={t4} className={leaderboardButtonClasses}>{t5}</button>;
    $[9] = leaderboardButtonClasses;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== firstDecisionDone || $[15] !== onViewChange || $[16] !== registerTabRef || $[17] !== winnersButtonClasses || $[18] !== winnersButtonTextClasses) {
    t7 = firstDecisionDone && <button ref={el_0 => {
      registerTabRef?.(BrainView.WINNERS, el_0);
    }} onClick={() => onViewChange(BrainView.WINNERS)} className={winnersButtonClasses}><span className={winnersButtonTextClasses}>Winners</span></button>;
    $[14] = firstDecisionDone;
    $[15] = onViewChange;
    $[16] = registerTabRef;
    $[17] = winnersButtonClasses;
    $[18] = winnersButtonTextClasses;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== renderAfterLeaderboard || $[21] !== t6 || $[22] !== t7) {
    t8 = <>{t6}{renderAfterLeaderboard}{t7}</>;
    $[20] = renderAfterLeaderboard;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default MyStreamWaveTabsLeaderboard;